"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _lodash = _interopRequireDefault(require("lodash"));

var _styling = require("../../../../toolkit/styling");

var _providers = require("../../../../toolkit/providers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = (0, _mobxReact.observer)(function (props) {
  var row = props.row,
      section = props.section,
      rowIndex = props.rowIndex,
      column = props.column,
      className = props.className,
      style = props.style;
  var title = column.title; // _.get() is needed here because of the nested dynamic access.
  // Can't be accomplished with optional chaining.
  // eslint-disable-next-line local-rules/no-unnecessary-use-of-lodash

  var cell = _lodash["default"].get(row.row, column.columnKey);

  var styles = useStylesheet(props);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(className, style, styles.root)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.title)
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.value)
  }, /*#__PURE__*/_react["default"].cloneElement(column.component, _objectSpread({
    row: row.row,
    index: rowIndex,
    value: cell,
    section: section
  }, column))));
});

exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref) {
  var cellIndex = _ref.cellIndex;

  var _useTheming = (0, _providers.useTheming)(),
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
        padding: "8px 10px"
      },
      title: {
        fontFamily: cellIndex == 0 ? fonts.bold : fonts.semibold,
        fontSize: cellIndex == 0 ? 25 : 18,
        marginRight: 40
      },
      value: {
        maxWidth: "50%"
      }
    });
  }, [cellIndex, fonts.bold, fonts.semibold]);
};